import { Accordion, Stack } from "basis";
import { Separator } from "components/Separator/Separator";
import { ReviewAccount } from "pages/HardshipApplication/Review/YourAccountsAccordion/ReviewAccount";
import { useHardshipApplicationContext } from "../../hooks/useHardshipApplicationContext";

type YourAccountsAccordionProps = {
  region: string;
};

export const YourAccountsAccordion = ({
  region,
}: YourAccountsAccordionProps) => {
  const {
    state: { yourAccounts },
  } = useHardshipApplicationContext();

  return (
    <Accordion>
      <Accordion.Item initiallyOpen>
        <Accordion.Item.Header>Your accounts</Accordion.Item.Header>
        <Accordion.Item.Content>
          {yourAccounts?.accounts.map((account, index) => (
            <Stack gap="4" key={index} margin={index === 0 ? "" : "4 0 0"}>
              {index !== 0 && <Separator />}
              <ReviewAccount account={account} index={index} region={region} />
            </Stack>
          ))}
        </Accordion.Item.Content>
      </Accordion.Item>
    </Accordion>
  );
};
